import {
    selectSet,
    selectPendingUploadsForSet,
    selectUploadsForSetSummary,
    deleteUpload,
    uploadFlight,
    stageFiles,
    setSplitButtonOpen,
    selectSplitButtonOpen,
    selectSelectedUpload,
    selectStatusCheckerOpen,
    setSelectedUpload,
    setStatusCheckerOpen,
    selectImageColorFinderMockJob,
} from "./ImageColorFinderSlice"
import {
    FileUploadCategory,
    supportedFileUploadExtensions,
} from "features/job-management/uploader/constants"
import {
    selectColorFinderImageById,
    selectColorFinderImagesAndUploadsByFlightId,
    selecteColorfinderImagesAndUploadsWithContextByFlightId,
    selectImageColorfinderFinishedUploadSize,
    selectImageColorfinderUploadSize,
    selectIsImageColorfinderFlightUploading,
    selectSummaryFromImageColorfinderUploads,
} from "features/entity-caching/images/colorfinder/selectors"
import { deleteColorFinderImage } from "features/pubsub/entityActions/images/colorFinder"
import { selectImageColorFinderFlightById } from "features/entity-caching/flights/selectors"
import { updateImageColorFinderFlight } from "features/pubsub/entityActions/flights/imageColorFinder"
import { ImagePreviewType } from "@nova/constants"
import {
    CreateImagePreviewModal,
    CreateImagePreviewModalProps,
} from "panels/content/side-panel/upload-flow/preview-files/GenericImagePreviewModal"
import { ImageColorfinderUploadFlowWarnings } from "./ImageColorfinderWarnings"
import { openColorFinder } from "../V2/redux/slice"
import store from "integrations/redux/store"
export const imageColorFinderProps = {
    selectSet,
    selectUploadsForSet: selecteColorfinderImagesAndUploadsWithContextByFlightId,
    selectUploadsForSetSummary,
    selectPendingUploadsForSet,
    deleteUpload,
    deleteUploadedUpload: deleteColorFinderImage,
    uploadFlight,
    stageFiles,
    fileTypeSeparator: ", ",
    setSplitButtonOpen,
    selectSplitButtonOpen,
    selectSelectedUpload,
    selectStatusCheckerOpen,
    setSelectedUpload,
    setStatusCheckerOpen,
    supportedFileTypes: ["jpg", "jpeg"],
    minUploads: 1,
    warningDefinitions: {},
    supportedFileUploadExtensions: supportedFileUploadExtensions[FileUploadCategory.VisibleImages],
    selectFlightById: selectImageColorFinderFlightById,
    updateFlight: updateImageColorFinderFlight,
    selectIsUploading: selectIsImageColorfinderFlightUploading,
    selectUploadSize: selectImageColorfinderUploadSize,
    selectFinishedUploadSize: selectImageColorfinderFinishedUploadSize,
    selectUploadStateSummary: selectSummaryFromImageColorfinderUploads,
    uploadFlowWarnings: ImageColorfinderUploadFlowWarnings,
    imagePreviewType: ImagePreviewType.Colorfinder,
    secondaryPreviewAction: {
        title: "View Color Data",
        onClick: (id: string) => {
            store.dispatch(openColorFinder({ flightId: id }))
        },
    },
}

export const ColorfinderImagePreviewModal = CreateImagePreviewModal({
    imagePreviewType: ImagePreviewType.Colorfinder,
    selectUploadsForSet: selectColorFinderImagesAndUploadsByFlightId,
    deleteUpload: deleteUpload,
    deleteUploadedUpload: deleteColorFinderImage,
    selectImageById: selectColorFinderImageById,
    selectJobByFlightId: selectImageColorFinderMockJob,
    selectFlightById: selectImageColorFinderFlightById,
} as CreateImagePreviewModalProps)
